import {
  ADD_CLAIMS_TO_LIST,
  CLEAR_CLAIMS,
  DELETE_CLAIMS_FROM_LIST,
  EDIT_CLAIMS_IN_LIST,
  SET_CLAIMS,
} from '../types/claims-types';

import { claimsInitialState } from 'store/initial-states/claims-initial-state';

export const claimsReducer = (state = claimsInitialState, action) => {
  switch (action.type) {
    case SET_CLAIMS:
      return action.payload;

    case ADD_CLAIMS_TO_LIST:
      return [...state.claims, action.payload];

    case EDIT_CLAIMS_IN_LIST:
      return state.claims.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload.updatedData } : item
      );

    case DELETE_CLAIMS_FROM_LIST:
      return state.claims.filter((item) => item.id !== action.payload);

    case CLEAR_CLAIMS:
      return claimsInitialState;

    default:
      return state;
  }
};
